module.exports = __webpack_public_path__ + "static/img/07.f60b50bb.png";